export default __webpack_public_path__ + "static/media/002-ice cream shop.660c962e.svg";